import React, { useContext, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import BreadcrumbBar from "components/BreadcrumbBar.js";
import Preloader from "../components/preloader";
import SitewideDataContext from "../utils/sitewideContext";

// dynamically create dashboard routes
import routes from "routes.js";

import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import axios from "../utils/axiosConfig";
import "../constants/service_constants";

export const Admin = () => {
  const { sitewideData, setSitewideData } = useContext(SitewideDataContext);
  const { getAccessTokenSilently } = useAuth0();
  const fetchedUserRef = useRef(false);

  // Load user info once so Sidebar can show admin menu / debug for admins
  useEffect(() => {
    if (fetchedUserRef.current || sitewideData.userInfo) return;
    fetchedUserRef.current = true;
    getAccessTokenSilently()
      .then((token) => {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        return axios.get(API_ADDRESS + USER_ENDPOINT);
      })
      .then((res) => {
        setSitewideData((prev) => ({ ...prev, userInfo: res.data }));
      })
      .catch(() => {});
  }, [getAccessTokenSilently, setSitewideData, sitewideData.userInfo]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/") {
        return (
          <Route
            path={prop.layout + prop.path}
            key={key}
            component={prop.component}
          />
        );
      } else {
        return null;
      }
    });
  };
  return (
    <>
      <div className="wrapper">
        {sitewideData.overloading ? <Preloader logo overlay text active /> : null}
        <Sidebar routes={routes} />
        <div className="main-panel">
          <BreadcrumbBar routes={routes} />
          <div className="content">
            <Switch>
              {getRoutes(routes)}
              <Redirect from="*" to="/dashboard"/>
            </Switch>
          </div>
          <AdminFooter/>
          <div
            className="close-layer"
            onClick={() =>
              document.documentElement.classList.toggle("nav-open")
            }
          />
        </div>
      </div>
    </>
  );
}


export default withAuthenticationRequired(Admin);